import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Title } from '@mantine/core'
import { GeneralAccordion } from '@/components/Elements'
import useStyles from './Component.styles'

export const FAQContainer = () => {
  const { t } = useTranslation()

  const { classes } = useStyles()

  const items = Array.from({ length: 6 }, (_, i) => ({
    control: 'Question',
    panel:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  }))

  return (
    <>
      <Box mb={'xl'}>
        <Title order={3}>{t('frequently_asked_questions')}</Title>
      </Box>

      <GeneralAccordion
        variant={'separated'}
        items={items.map(({ control, panel }, index) => ({
          control: `${control} ${index + 1}`,
          panel,
          value: `${index}`,
        }))}
        classNames={{
          control: classes.control,
        }}
      />
    </>
  )
}
